import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { axiosClient } from '../api/proxy/AxiosClient';

const LoginContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

const LoginForm = styled.div`
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    width: 300px;
`;

const Title = styled.h2`
    color: #333;
    text-align: center;
    margin-bottom: 20px;
`;

const ErrorText = styled.p`
    color: red;
    text-align: center;
    font-size: 14px;
`;

export default function ActivationPage() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');

    if (!code) {
      setStatus('error');
      setErrorMessage('Activation link is invalid or missing.');
      return;
    }

    let cancelled = false;

    axiosClient.post('/auth/activate/', { code })
      .then((response) => {
        if (!cancelled) {
          navigate(`/login?activated&email=${response.data.email}`, { replace: true });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setStatus('error');
          setErrorMessage('Activation failed. The link may be expired or already used. Check your e-mail for a new activation link or contact support: admin@k2e.space');
        }
      });

    return () => { cancelled = true; };
  }, [navigate]);

  return (
    <LoginContainer>
      <LoginForm>
        <Title>Account Activation</Title>
        {status === 'loading' && <p style={{ textAlign: 'center' }}>Activating your account…</p>}
        {status === 'error' && <ErrorText>{errorMessage}</ErrorText>}
      </LoginForm>
    </LoginContainer>
  );
}
